const Files = ({ color = '#6A1099', height = 24, width = 30 }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.96169 9.05146C1.96169 8.80294 2.16317 8.60146 2.41169 8.60146H10.1264V15.9926V16.5426H10.6764L17.4058 16.5426V27.5662C17.4058 27.8147 17.2043 28.0162 16.9558 28.0162H2.41169C2.16317 28.0162 1.96169 27.8147 1.96169 27.5662V9.05146ZM17.4058 15.4426V15.1115C17.4058 14.9847 17.3523 14.8638 17.2585 14.7785L11.2264 9.29477V15.4426L17.4058 15.4426ZM2.41169 7.50146C1.55565 7.50146 0.861694 8.19542 0.861694 9.05146V27.5662C0.861694 28.4222 1.55565 29.1162 2.41169 29.1162H16.9558C17.8119 29.1162 18.5058 28.4222 18.5058 27.5662V15.1115C18.5058 14.6748 18.3216 14.2583 17.9985 13.9646L11.3324 7.90456C11.0471 7.64518 10.6754 7.50146 10.2898 7.50146H2.41169Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.04402 0.883789C6.18798 0.883789 5.49402 1.57775 5.49402 2.43379V8.05144H6.59402V2.43379C6.59402 2.18526 6.79549 1.98379 7.04402 1.98379H14.7587V9.37497V9.92497H15.3087L22.0381 9.92496V20.9485C22.0381 21.197 21.8367 21.3985 21.5881 21.3985H17.9558V22.4985H21.5881C22.4442 22.4985 23.1381 21.8045 23.1381 20.9485V8.49381C23.1381 8.0571 22.9539 7.64066 22.6308 7.3469L15.9648 1.28688C15.6794 1.02751 15.3077 0.883789 14.9221 0.883789H7.04402ZM22.0381 8.82497V8.49381C22.0381 8.36702 21.9847 8.24612 21.8908 8.16083L15.8587 2.67709V8.82497L22.0381 8.82497Z"
      fill={color}
    />
  </svg>
);

export default Files;
